import { render, staticRenderFns } from "./BomList.vue?vue&type=template&id=bd463074&scoped=true"
import script from "./BomList.vue?vue&type=script&lang=js"
export * from "./BomList.vue?vue&type=script&lang=js"
import style0 from "./BomList.vue?vue&type=style&index=0&id=bd463074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd463074",
  null
  
)

export default component.exports